/**
 * Next `routeChange*` events pass `asPath` (`/b/<uuid>`), while `router.pathname` is the
 * pattern (`/b/[boardId]`). Both forms always start with one of these prefixes, so a single
 * prefix check covers every libraries/boards route regardless of which form is passed in.
 */
const LIBRARIES_SUB_SIDE_NAV_AS_PATH_PREFIXES = ['/b/', '/l/'] as const;

export const isLibrariesSubSideNavPathname = (pathname: string) =>
  LIBRARIES_SUB_SIDE_NAV_AS_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix));
